import styled from "styled-components";
import { Menu, Popover } from "antd";
import { alpha, IconButton } from "@mui/material";
import { primaryColor } from "../styled/Theme";
import { DocumentTextOutline } from "@raresail/react-ionicons";
import {
  // URL_LEDGER_REPORT,
  URL_LOAN_APPLICATIONS_REPORT,
  URL_LOAN_REPAYMENTS_REPORT,
} from "../../utils/urls";
import { ActionsMenu } from "../common/FormActions";
import { useAuth } from "../../context/AuthContext";
export const reportSettings = [
  {
    label: "Financial Reports",
    icon: DocumentTextOutline,
    to: "/reports/balance-sheet",
    permissions: ["can_view_financial_report"],
  },
  {
    label: "Adhoc Reports",
    icon: DocumentTextOutline,
    to: "/reports/adhoc",
    permissions: ["can_view_adhoc_report"],
  },
  {
    label: "Debtors Aging Reports",
    icon: DocumentTextOutline,
    to: "/reports/debtors-ageing-report",
    permissions: ["can_view_debtors_ageing_report"],
  },
  {
    label: "Transactions Report",
    icon: DocumentTextOutline,
    to: "/reports/transactions",
    permissions: ["can_view_transactions_bikes_report"],
  },
  {
    label: "Charts of Accounts Report",
    icon: DocumentTextOutline,
    to: "/reports/charts-of-accounts",
    permissions: ["can_view_chart_of_accounts_report"],
  },
  {
    label: "Invoice List Report",
    icon: DocumentTextOutline,
    to: "/reports/invoice-list",
    permissions: ["can_view_invoice_list_report"],
  },
  {
    label: "Payments Report",
    icon: DocumentTextOutline,
    to: "/reports/payments",
    permissions: ["can_view_purchase_orders"],
  },
  {
    label: "Over Payments Report",
    icon: DocumentTextOutline,
    to: "/reports/over-payments",
    permissions: ["can_view_purchase_orders"],
  },
  {
    label: "Loan Book Report",
    icon: DocumentTextOutline,
    to: "/reports/loan-book",
    permissions: ["can_view_loan_book_report"],
  },
  {
    label: "Loan Instalment Report",
    icon: DocumentTextOutline,
    to: "/reports/loan-instalment",
    permissions: ["can_view_loan_instalment_report"],
  },
  {
    label: "Loan Repayments Report",
    icon: DocumentTextOutline,
    to: URL_LOAN_REPAYMENTS_REPORT,
    permissions: ["can_view_loan_repayments_report"],
  },
  {
    label: "Loan Applications Report",
    icon: DocumentTextOutline,
    to: URL_LOAN_APPLICATIONS_REPORT,
    permissions: ["can_view_loan_applications_report"],
  },
  {
    label: "Active Clients Report",
    icon: DocumentTextOutline,
    to: "/reports/active-clients-report",
    permissions: ["can_view_active_clients_report"],
  },
  // {
  //   label: "Ledger Report",
  //   icon: DocumentTextOutline,
  //   to: URL_LEDGER_REPORT,
  //   permissions: ["can_view_ledger_report"],
  // },
  {
    label: "Expenses Report",
    icon: DocumentTextOutline,
    to: "/reports/expenses",
    permissions: ["can_view_expenses_report"],
  },
  {
    label: "Fines Report",
    icon: DocumentTextOutline,
    to: "/reports/fines",
    permissions: ["can_view_fines_report"],
  },
  {
    label: "Impounded Bikes Report",
    icon: DocumentTextOutline,
    to: "/reports/impounded-bikes",
    permissions: ["can_view_impounded_bikes_report"],
  },
  {
    label: "Stolen Bikes Report",
    icon: DocumentTextOutline,
    to: "/reports/stolen-bikes",
    permissions: ["can_view_stolen_bikes_report"],
  },
  {
    label: "Released Bikes Report",
    icon: DocumentTextOutline,
    to: "/reports/released-bikes",
    permissions: ["can_view_released_bikes_report"],
  },
];
const ReportsDropdown = () => {
  const { user } = useAuth();
  const permissions = user?.role_details?.[0]?.permissions ?? [];
  return (
    <>
      <Popover
        content={
          <Menu mode="inline" className="font13 rightmenu">
            {ActionsMenu(
              reportSettings
                .sort((a, b) => a.label.localeCompare(b.label))
                .filter((report) => {
                  if (report.permissions) {
                    const userPermissionCodes = permissions?.map(
                      (permission: any) => permission.codename,
                    );
                    return report.permissions.some(
                      (requiredPermission: string) =>
                        userPermissionCodes?.includes(requiredPermission),
                    );
                  }
                  return true; // Show reports without specific permissions
                }),
            )}
          </Menu>
        }
        trigger="click"
        overlayStyle={{ minWidth: 200 }}
        overlayInnerStyle={{ padding: 5 }}
        placement="bottomRight"
      >
        <AvatarWrapper className="animate">
          <IconButton
            sx={{
              bgcolor: alpha(primaryColor, 0.1),
              borderRadius: 10,
              padding: "0.5rem 1rem",
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: "#555",
            }}
          >
            <DocumentTextOutline className="font13" />
            <span className="font13">Reports</span>
          </IconButton>
        </AvatarWrapper>
      </Popover>
    </>
  );
};

export default ReportsDropdown;

const AvatarWrapper = styled.div`
  &:hover {
    scale: 1.03;
  }
`;
